import axios from "axios";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { FinMasonError, FinMasonErrorResponse } from "../types";
export const portfolioPlanPerformanceByIdURL = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}/performance`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}/performance`;
const NullableOrNumber = z
    .string()
    .transform((x) => new Decimal(x))
    .nullable();
const PortfolioPlanPerformance = z.object({
    data: z.object({
        return1Year: NullableOrNumber,
        return3Year: NullableOrNumber,
        return5Year: NullableOrNumber,
        return10Year: NullableOrNumber,
        finscore: NullableOrNumber,
    }),
});
export const getPortfolioPlanPerformanceById = async (portfolioPlanId, config) => {
    const { data, status } = await axios.get(portfolioPlanPerformanceByIdURL(portfolioPlanId), {
        headers: {
            version: "20240912",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
        validateStatus: () => true,
    });
    if (status === 550) {
        const parsed = FinMasonErrorResponse.parse(data);
        if (parsed.details.statusCode === "FIN_MASON_UNKNOWN_ASSET") {
            return new FinMasonError(parsed.message, parsed.details.invalidPositions);
        }
        throw new Error("Unexpected FinMason error");
    }
    if (status >= 300) {
        const errorMessage = `[${getPortfolioPlanPerformanceById.name}] received status code ${status}`;
        errorLog(errorMessage, data);
        throw new Error(errorMessage);
    }
    const decoded = PortfolioPlanPerformance.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    const errorMessage = `[getPortfolioPlanPerformanceById.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=getPortfolioPlanPerformanceById.js.map